// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ids-popup::part(popup) {
  padding-block: 0;
  width: 100%;
}

ids-popup[visible][animated] {
  transition: none;
}

.ids-date-picker-popup .ids-popup.menu {
  padding-block: 0;
}

ids-month-view {
  width: 100%;
}

#month-year-view-trigger {
  margin: 4px;
}

.ids-date-picker-popup {
  min-width: 350px;
}
.ids-date-picker-popup:not(.has-time) ids-month-view::part(table-container) {
  margin-bottom: 10px;
}
.ids-date-picker-popup ids-popup::part(popup) {
  padding-block: 0;
}
.ids-date-picker-popup .popup-footer:not(.hidden) {
  border-top: 1px solid var(--ids-date-picker-popup-footer-color-border);
  display: flex;
}
.ids-date-picker-popup .popup-footer:not(.hidden) ids-modal-button:not([hidden]) + ids-modal-button,
.ids-date-picker-popup .popup-footer:not(.hidden) .ids-modal-button:not([hidden]) + .ids-modal-button {
  border-left: 1px solid;
  border-left-color: var(--ids-date-picker-popup-footer-color-border);
}
.ids-date-picker-popup .popup-btn {
  width: 100%;
}

.ids-date-picker-content {
  position: relative;
}

ids-expandable-area {
  display: block;
}

ids-expandable-area:not([expanded]),
ids-expandable-area[expanded=false] {
  pointer-events: none;
}

ids-expandable-area::part(container) {
  margin: 0;
  padding: 0;
  height: 100%;
  position: absolute;
  z-index: 3;
  border: none;
  left: 0;
  width: 100%;
}

ids-expandable-area::part(header) {
  display: none;
}

ids-expandable-area::part(pane) {
  background-color: var(--ids-date-picker-color-background);
}

ids-expandable-area::part(footer) {
  display: none;
}

ids-expandable-area::part(pane-content) {
  margin-top: 0;
  height: 100%;
}

ids-time-picker-popup {
  display: flex;
  justify-content: center;
}
ids-time-picker-popup[hidden] {
  display: none;
}
ids-time-picker-popup[embeddable] {
  margin-top: -18px;
}

.month-year-container {
  width: 100%;
  margin-top: 4px;
  margin-bottom: auto;
  justify-content: center;
  display: flex;
  gap: 8px;
}

.btn-today::part(button) {
  padding-block: 7px;
  padding-inline: unset;
}

.btn-today-text {
  color: var(--ids-date-picker-popup-button-today-color-text);
}

.btn-previous::part(button),
.btn-next::part(button) {
  width: 34px;
  height: 34px;
}

.btn-previous {
  padding-inline-start: 8px;
  padding-block: 5px;
}

.btn-next {
  padding-inline-end: 8px;
  padding-block: 5px;
  padding-inline-start: 2px;
  margin-top: 2px;
}

.popup-btn-group.hidden {
  display: none;
}
.popup-btn-group .btn-today:has(~ .popup-btn:not([hidden]))::part(button) {
  width: 58px;
}

.today-btn-group.hidden {
  display: none;
}

.dropdown-text-trigger:focus-visible {
  outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-date-picker/ids-date-picker-popup.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,WAAA;AAAF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,gBAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKE;EACE,sEAAA;EACA,aAAA;AAHJ;AAKI;;EAEE,sBAAA;EACA,mEAAA;AAHN;AAOE;EACE,WAAA;AALJ;;AASA;EACE,kBAAA;AANF;;AAYA;EACE,cAAA;AATF;;AAYA;;EAEE,oBAAA;AATF;;AAYA;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,yDAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,aAAA;EACA,YAAA;AATF;;AAeA;EACE,aAAA;EACA,uBAAA;AAZF;AAcE;EACE,aAAA;AAZJ;AAeE;EACE,iBAAA;AAbJ;;AAiBA;EACE,WAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,QAAA;AAdF;;AAqBE;EACE,kBAAA;EACA,qBAAA;AAlBJ;;AAsBA;EACE,2DAAA;AAnBF;;AAwBE;;EACE,WAAA;EACA,YAAA;AApBJ;;AAwBA;EACE,yBAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AArBF;;AAyBE;EACE,aAAA;AAtBJ;AA0BI;EACE,WAAA;AAxBN;;AA6BA;EACE,aAAA;AA1BF;;AA8BE;EACE,wBAAA;AA3BJ","sourcesContent":["// Date Picker Popup padding reset\nids-popup::part(popup) {\n  padding-block: 0;\n  width: 100%;\n}\n\n// Remove left/top transforms from animation on this component's popup\nids-popup[visible][animated] {\n  transition: none;\n}\n\n.ids-date-picker-popup .ids-popup.menu {\n  padding-block: 0;\n}\n\nids-month-view {\n  width: 100%;\n}\n\n#month-year-view-trigger {\n  margin: 4px;\n}\n\n.ids-date-picker-popup {\n  min-width: 350px;\n\n  &:not(.has-time) ids-month-view::part(table-container) {\n    margin-bottom: 10px;\n  }\n\n  ids-popup::part(popup) {\n    padding-block: 0;\n  }\n\n  .popup-footer:not(.hidden) {\n    border-top: 1px solid var(--ids-date-picker-popup-footer-color-border);\n    display: flex;\n\n    ids-modal-button:not([hidden]) + ids-modal-button,\n    .ids-modal-button:not([hidden]) + .ids-modal-button {\n      border-left: 1px solid;\n      border-left-color: var(--ids-date-picker-popup-footer-color-border);\n    }\n  }\n\n  .popup-btn {\n    width: 100%;\n  }\n}\n\n.ids-date-picker-content {\n  position: relative;\n}\n\n// =====================================\n// IdsExpandableArea\n\nids-expandable-area {\n  display: block;\n}\n\nids-expandable-area:not([expanded]),\nids-expandable-area[expanded='false'] {\n  pointer-events: none;\n}\n\nids-expandable-area::part(container) {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  position: absolute;\n  z-index: 3;\n  border: none;\n  left: 0;\n  width: 100%;\n}\n\nids-expandable-area::part(header) {\n  display: none;\n}\n\nids-expandable-area::part(pane) {\n  background-color: var(--ids-date-picker-color-background);\n}\n\nids-expandable-area::part(footer) {\n  display: none;\n}\n\nids-expandable-area::part(pane-content) {\n  margin-top: 0;\n  height: 100%;\n}\n\n// =====================================\n// Timepicker\n\nids-time-picker-popup {\n  display: flex;\n  justify-content: center;\n\n  &[hidden] {\n    display: none;\n  }\n\n  &[embeddable] {\n    margin-top: -18px;\n  }\n}\n\n.month-year-container {\n  width: 100%;\n  margin-top: 4px;\n  margin-bottom: auto;\n  justify-content: center;\n  display: flex;\n  gap: 8px;\n}\n\n// =====================================\n// Footer buttons\n\n.btn-today {\n  &::part(button) {\n    padding-block: 7px;\n    padding-inline: unset;\n  }\n}\n\n.btn-today-text {\n  color: var(--ids-date-picker-popup-button-today-color-text);\n}\n\n.btn-previous,\n.btn-next {\n  &::part(button) {\n    width: 34px;\n    height: 34px;\n  }\n}\n\n.btn-previous {\n  padding-inline-start: 8px;\n  padding-block: 5px;\n}\n\n.btn-next {\n  padding-inline-end: 8px;\n  padding-block: 5px;\n  padding-inline-start: 2px;\n  margin-top: 2px;\n}\n\n.popup-btn-group {\n  &.hidden {\n    display: none;\n  }\n\n  .btn-today {\n    &:has(~ .popup-btn:not([hidden]))::part(button){\n      width: 58px;\n    }\n  }\n}\n\n.today-btn-group.hidden {\n  display: none;\n}\n\n.dropdown-text-trigger {\n  &:focus-visible {\n    outline: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
